/**
 * Caminhos de campo do documento (`atributos.forca`): nomes de letras sem acento, números e `_`,
 * começando por letra ou `_`, separados por ponto. Maiúsculas não contam (como em todo o NDB), e
 * os nomes que começam com `_rpgdesk` são do RPG Desk (docs/spec/web-plugins.md, "Caminhos").
 */
import { MESSAGES, type Lang } from './messages.js';

export const FIELD_NAME = /^[A-Za-z_][A-Za-z0-9_]*$/;
export const MAX_FIELD_NAME = 64;
export const MAX_FIELD_DEPTH = 12;

export const isReservedName = (name: string): boolean => name.toLowerCase().startsWith('_rpgdesk');

/** O que há de errado no caminho, ou null se está bom. */
export function fieldPathProblem(path: string, lang: Lang = 'pt'): string | null {
  const M = MESSAGES[lang].field;
  if (typeof path !== 'string' || path.trim() === '') return M.empty;
  if (path !== path.trim()) return M.spaces(path);
  const parts = path.split('.');
  if (parts.length > MAX_FIELD_DEPTH) return M.depth(path, MAX_FIELD_DEPTH);
  for (const part of parts) {
    if (part === '') return M.dot(path);
    if (part.length > MAX_FIELD_NAME) return M.long(part, MAX_FIELD_NAME);
    if (!FIELD_NAME.test(part)) return M.invalid(part);
    if (isReservedName(part)) return M.reserved(part);
  }
  return null;
}

export const splitFieldPath = (path: string): string[] => path.split('.');
